import React, { useState } from 'react';
import * as env from 'config/environment';
import * as consts from 'config/consts';
import { useLocation } from 'react-router-dom';
import { sendInvestorProvisionalRegistrationEmail } from 'config/api';
import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import Loading from 'components/commons/loading/Loading';
import { getUserStorage } from 'components/features/utils/utils';
import { useRouting } from 'hooks/useRouting';

export const footerText = () => {
  return (
    <div className="lg:px-0 px-6 py-4 text-xs text-bluegray-500 leading-5">
      <div>
        ※資産データリンクは、株式会社MONO
        Investmentが提供する『投資のコンシェルジュ』と同一のシステムを利用しているサービスです。
      </div>
      <div>
        ※ 既に資産データリンクもしくは株式会社MONO
        Investmentが提供しているサービスに同じメールアドレスでご登録している場合は別途手続きが必要になる可能性があります。
      </div>
    </div>
  );
};

const InvestorIdExplanation: React.FC = () => {
  const user = getUserStorage();
  const { pathname } = useLocation();
  const { pushRouting } = useRouting();
  const { setWithNavigation } = useCustomizeHeaderContext();
  setWithNavigation(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const linkChangeAddress = `${
    env.accountSettingURL
  }/email_change_offers?service=${env.serviceName}&callback_url=${encodeURI(
    `${env.appURL}/Auth?callbackPath=${pathname}`
  )}`;

  if (user === null) return <></>;

  const goMomoAccountRegister = async (): Promise<void> => {
    if (isLoading) return;
    setIsLoading(true);

    const url = '/Auth?callbackPath=/home';

    try {
      const ret = await sendInvestorProvisionalRegistrationEmail({
        email: user.MailAddress,
        redirectPath: url,
      });
      setIsLoading(false);

      if (ret.ResultCode === consts.InvestorRegistrationResultCode.正常終了) {
        const linkToMono = `${env.monoAccountRegisterURL}/verifyToken?emailToken=${ret.MailToken}&userCompanyCode=MINKABU`;
        window.location.replace(linkToMono);
      } else if (
        ret.ResultCode ===
        consts.InvestorRegistrationResultCode.メールアドレス重複
      ) {
        pushRouting({ path: '/investoridregistrationerror/duplication' }, true);
      } else if (
        ret.ResultCode === consts.InvestorRegistrationResultCode.異常終了
      ) {
        pushRouting({ path: '/investoridregistrationerror/exception' }, true);
      } else {
        pushRouting({ path: '/investoridregistrationerror/exception' }, true);
      }
    } catch {
      pushRouting({ path: '/investoridregistrationerror/exception' }, true);
    }
  };

  return (
    <>
      <div className="max-w-md mx-auto relative">
        <div className="p-6 bg-white">
          <div className="mt-4 font-bold text-center">
            アセプラをご利用になるためには
            <br />
            資産データリンクにご登録が必要です
          </div>
          <div
            className="grid items-center mt-4 py-8 border border-neutral-400 rounded-lg"
            style={{ gridTemplateColumns: '1fr auto 1fr' }}>
            <img
              src="https://assets.minkabu.jp/images/logo/v4/logo_minkabu.svg"
              width="80"
              height="20"
              alt="みんかぶ"
              className="mx-auto"
            />
            <img
              src="/static/images/arrow_circle.svg"
              width="48"
              height="48"
              alt=""
            />
            <div className="flex flex-col items-center mx-auto">
              <img
                src="/static/images/logo_mono.svg"
                width="58"
                height="58"
                alt=""
              />
              <div className="text-1.5xs">資産データリンク</div>
              <div className="text-2xs">(投資のコンシェルジュ)</div>
            </div>
          </div>
          <div className="mt-4 text-sm leading-6">
            登録をすることで投資商品や資産の情報を円滑にアセプラで表示することができるようになります。ご利用にあたりメールアドレスの登録をお願いします。
          </div>
          <div className="mt-4 text-xs font-bold">登録中のメールアドレス</div>
          <div className="w-full mt-2 py-2 px-2 text-sm bg-gray-225 rounded-lg">
            {user ? user.MailAddress : ''}
          </div>
          <a href={linkChangeAddress}>
            <div className="mt-2 text-right text-sm text-blue-700">
              メールアドレスを変更する
            </div>
          </a>
          <button
            className="w-full mt-6 py-3 text-center font-bold text-white bg-bluegray-700 rounded-lg justify-center flex"
            onClick={goMomoAccountRegister}
            disabled={isLoading}>
            {isLoading ? (
              <>
                <Loading
                  loading
                  circularLoading
                  style={{ width: '45px', height: '27px' }}
                />
              </>
            ) : (
              '続ける'
            )}
          </button>
        </div>
        {footerText()}
      </div>
    </>
  );
};

export default InvestorIdExplanation;
